module.exports = __webpack_public_path__ + "assets/img/icon2.df8ca8ee.png";